'use strict';
var React = require('react');
var BaseClassComponent = require('../../shared/base.jsx');
var EnumCoreModule = require('../../../../src/public/js/enum-core.js');
var Numeral = require('numeral');
var Moment = require('moment');
var Currency = require('currency-symbol-map');

let client = require('../../../../sdk/client');
//var AddressSettingsButton = require(`./address-settings-button`);

class CreditLineSettingsComponent extends BaseClassComponent {
    constructor(props) {
        super(props);

        this.state = {
            credits: {}
        }
    }

    componentDidMount() {
        this.getCreditRequest()
    }

    getCreditRequest() {
        var cfUser = this.props.user.CustomFields;
        var customerID;
        if(cfUser != null){
            cfUser.map(function (cf) {
                if (cf.Name === process.env.NAME_CF_CLIENTE_ID) {
                    customerID = cf.Values[0];
                }
            }, this);
            client.CreditInformation.getCreditInformation(customerID)
                .then((response) => {
                    //console.log("response Credits")
                    //console.log(response)
                    this.setState({
                        credits: response
                    });
                },
                    (error) => {
                        //console.log(error);
                    }
                );
        }
    }

    showCreditsList() {
        let format = process.env.MONEY_FORMAT;
        //console.log(this.state.credits.currencyCredits)
        if (this.state.credits.Message == "Éxito") {
            if (this.state.credits.CurrencyCredits) {
                return this.state.credits.CurrencyCredits.map(function (creditItem) {
                    //console.log(creditItem)
                    var creditused = creditItem.CreditUsed + creditItem.ReservedCredit;
                    return <div key={creditItem.CurrencyCode} className="col-md-4 container-credits-table" style={{ 'border': '1px solid #d2d2d2' }}>
                        <div className="lbl-currencyCode" style={{ 'paddingBottom': '15px' }}>Moneda: {creditItem.CurrencyCode}</div>
                        <table className="cost-table credits-table" key={creditItem.CurrencyCode}>
                            <tbody>
                                <tr>
                                    <th></th>
                                </tr>
                                <tr>
                                    <td>Plazo de crédito: </td>
                                    <td><span className="item-price">{creditItem.CreditDays} días</span></td>
                                </tr>
                                <tr>
                                    <td>Línea de crédito: </td>
                                    <td>
                                        <span className="item-price">
                                            <span className="currencySymbol"> {Currency(creditItem.CurrencyCode.trim())}</span>
                                            <span className="priceAmount"> {Numeral(creditItem.TotalCredit).format(format)}</span>
                                        </span>
                                    </td>

                                </tr>
                                <tr>
                                    <td>Monto utilizado: </td>
                                    <td>
                                        <span className="item-price">
                                            <span className="currencySymbol"> {Currency(creditItem.CurrencyCode.trim())}</span>
                                            <span className="priceAmount"> {Numeral(creditused).format(format)}</span>
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Saldo disponible: </td>
                                    <td>
                                        <span className="item-price">
                                            <span className="currencySymbol"> {Currency(creditItem.CurrencyCode.trim())}</span>
                                            <span className="priceAmount"> {Numeral(creditItem.AvailableCredit).format(format)}</span>
                                        </span>
                                    </td>
                                </tr>

                                <tr>
                                    <td>Estado de crédito: </td>
                                    <td>
                                        <span className="item-price">
                                            <span className="priceAmount"> {creditItem.ActiveCredit ? "Activo" : "Inactivo"}</span>
                                        </span>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>


                }, this);
            } else {
                return <label>Sin línea de crédito</label>;
            }

        } else {
            return <div key="error-request-credit" className="col-md-4 container-credits-table" style={{ 'border': '1px solid #d2d2d2' }}>
                <div className="lbl-currencyCode" style={{ 'paddingBottom': '15px' }}>Información de línea de crédito:</div>
                <table className="cost-table credits-table" key="error-request-credit-t">
                    <tbody>
                        <tr>
                            <th></th>
                        </tr>
                        <tr>
                            <th></th>

                            <th>Consulta de línea de crédito no disponible</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        }

    }

    doAddressDelete(e) {
        var self = this;
        self.props.deleteAddress(self.state.selectedAddressToDelete);
        $('#modalRemove').modal('hide');
    }



    render() {
        let self = this;
        return (
            <React.Fragment>

                <div id="Credit" className="tab-pane fade">
                    <div className="" id="encodeContainer">


                    </div>
                    <div className="" id="boxContainer">
                        <div className="pdc-boxs">
                            {
                                self.showCreditsList()
                            }
                        </div>
                        { /* <AddressSettingsButton updateUserToOnboard={this.props.updateUserToOnboard} user={this.props.user}/>*/}
                    </div>
                    <div className="settings-button">
                        <div className="btn-previous pull-left btn-secc-profile" onClick={(e) => { $('.nav-pills a:first').tab('show'); }}>Regresar</div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

module.exports = CreditLineSettingsComponent;